




















import { Component, Vue } from 'vue-property-decorator'
import { State } from 'vuex-class'
import { linkJump } from '@bilibili/utils-leona'
import logger from '@plat-components/utils2/_esm5/logger'
@Component({})
export default class Stage extends Vue {
  @State('currPoint') currPoint
  // 去抽奖
  goToLottery() {
    logger('resultpage_click', {
      periods: this.currPoint,
    })
    const link =
      'https://www.bilibili.com/blackboard/topic/activity-PIHmlZHHpz.html'
    linkJump({
      link,
    })
  }
  goToShare() {
    logger('share_click', {
      periods: this.currPoint,
    })
    this.$emit('onShare')
  }
}
